function $(selector, context = document) {
    return context.querySelector(selector);
}

function $$(selector, context = document) {
    return [].slice.call(context.querySelectorAll(selector));
}

function $id(id, context = document) {
    return context.getElementById(id);
}

function on(el, event, cb) {
    el.addEventListener(event, cb);
}

export {
    $,
    $$,
    $id,
    on
};


// WEBPACK FOOTER //
// ./js/util.js